module.exports = __webpack_public_path__ + "static/media/scott-tallon-walker-architects.d242cf2a.png";